import CheckboxChecked from './src/checkbox-checked-combined';
export default CheckboxChecked;